import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Container,
  Grid,
  TextField
} from '@material-ui/core';
import useLocales from '../../../hooks/useLocales';
import Page from '../../../components/Page';
import HeaderDashboard from '../../../components/HeaderDashboard';
import { getImageUrlFromPath } from '../../../redux/slices/cdn';
import { RootState } from '../../../redux/store';

// ----------------------------------------------------------------------

export const ALARMANDWARNING = [
  { id: 1, name: 'Alarm' },
  { id: 2, name: 'Warning' }
];

export default function AlarmDetail() {
  const { translate } = useLocales();
  const { alarmDetail } = useSelector((state: RootState) => state.alarmDetail);
  const [cameraName, setCameraName] = useState('');
  const [alarmType, setAlarmType] = useState('');
  const [imageUrl, setImageUrl] = useState('');

  // ----------------------------------------------------------------------
  useEffect(() => {
    if (alarmDetail.data && alarmDetail.data.data) {
      if (
        alarmDetail.data.data.alertDetail &&
        alarmDetail.data.data.alertDetail.name
      ) {
        setAlarmType(alarmDetail.data.data.alertDetail.name);
      }
      if (
        alarmDetail.data.data.cameraDetail &&
        alarmDetail.data.data.cameraDetail.name
      ) {
        setCameraName(alarmDetail.data.data.cameraDetail.name);
      }
      if (alarmDetail.data.data.image) {
        getImageUrlFromPath(alarmDetail.data.data.image).then((result) => {
          setImageUrl(result);
        });
      }
    }
  }, [alarmDetail]);

  // ----------------------------------------------------------------------

  return (
    <Page title={translate('alarm.detail.page.title')}>
      <Container maxWidth={false}>
        <HeaderDashboard
          heading={translate('alarm.detail.page.header')}
          links={[]}
          sx={{ marginBottom: '0px' }}
        />
        <Grid container spacing={3} sx={{ justifyContent: 'center' }}>
          <Grid item xs={12} sm={6} md={6}>
            <Card sx={{ height: '100%' }}>
              <Grid container>
                <Grid item md={6}>
                  <CardHeader title={translate('alarm.detail.show.image')} />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  {/* yeni ekledigim alarm details elementleri */}
                  <Grid
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      padding: '2rem'
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        maxWidth: '100%',
                        maxHeight: '100%'
                      }}
                      src={imageUrl}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Card sx={{ height: '100%' }}>
              <CardHeader title={translate('alarm.detail.information')} />

              <CardContent
                sx={{
                  // maxHeight: '300px',
                  padding: '10px',
                  marginTop: '24px'
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px'
                  }}
                >
                  <TextField
                    fullWidth
                    size="small"
                    disabled
                    value={cameraName}
                    label={translate('alarm.detail.camera.name')}
                  />
                  <TextField
                    fullWidth
                    size="small"
                    disabled
                    value={alarmType}
                    label={translate('alarm.detail.alarm.type')}
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
